<template>
  <EmDialog
    v-model="show"
    width="400"
    :title="title"
    :can-close="false"
  >
    <div v-if="contact" class="d-flex flex-column justify-center align-center height-100">
      <EmAvatar :name="contact.name" :phone-number="contact.phone" size="x-large" />
      <EmH2 class="mt-4">
        {{ contact.name }}
      </EmH2>
      <EmPhoneNumber :phone="contact.phone">
        <template #phone>
          <EmH3 class="text-neutral-lighten-2">
            {{ phoneFilter(contact.phone) }}
          </EmH3>
        </template>
      </EmPhoneNumber>
      <div class="mt-10" :style="{height: '40px'}">
        <CallDuration v-if="showDuration" size="large" />
      </div>
    </div>
    <template #buttons>
      <div class="pa-4 width-100">
        <slot name="buttons" />
      </div>
    </template>
  </EmDialog>
</template>

<script setup>
const { phone: phoneFilter } = useFilters()
const show = defineModel({ type: Boolean })
defineProps({
  title: { type: String, required: true },
  contact: { type: [Object, null], default: null },
  showDuration: { type: Boolean, default: false }
})
</script>
